// extracted by mini-css-extract-plugin
module.exports = {"textarea":"ThreadReply_textarea__1MtPe","component":"ThreadReply_component__2132I"};